import { useMutation } from '@tanstack/react-query';
import { sendPasswordReset } from '../services/auth';

export const useForgotPasswordMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ email, role }) => {
      const result = await sendPasswordReset(email, role);
      if (!result.success) {
        throw new Error(result.message || 'Failed to send password reset email');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
